
import Swiper, { Navigation } from 'swiper';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';


document.addEventListener('DOMContentLoaded', () => {
    new Swiper('.quotes-swiper', {
      // Optional parameters
      modules: [Navigation],
      direction: 'horizontal',
      loop: true,
    
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  })
